import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", icon: "ri-home-5-line" },
  { to: "/topics", label: "话题广场", icon: "ri-layout-grid-line" },
  { to: "/rank", label: "吃瓜热榜", icon: "ri-fire-line" },
  { to: "/about", label: "关于我们", icon: "ri-information-line" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "border-b border-background-200/70 bg-background-50/90 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between px-4 md:h-[68px] md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-chat-smile-2-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="brand-font text-xl text-foreground-950">深夜吃瓜</span>
            <span className="mt-0.5 text-[10px] tracking-[0.28em] text-foreground-500">TOPIC CLUB</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex items-center gap-1.5 whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              <i className={`${item.icon} text-base`} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/rank"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            <i className="ri-flashlight-line" />
            今晚热榜
          </Link>
          <Link
            to="/topics"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            <i className="ri-chat-new-line" />
            我要吃瓜
          </Link>
        </div>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/98 px-4 py-3 backdrop-blur-md md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                <i className={`${item.icon} text-lg`} />
                {item.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/topics"
            className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950"
          >
            <i className="ri-chat-new-line" />
            我要吃瓜
          </Link>
        </div>
      )}
    </header>
  );
}